/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Phone_BodyInputs */

const en_hood_phone_body = /** @type {(inputs: Hood_Phone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every screen works on a phone and meets WCAG 2.2 AA.`)
};

/**
* | output |
* | --- |
* | "Every screen works on a phone and meets WCAG 2.2 AA." |
*
* @param {Hood_Phone_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_phone_body = /** @type {((inputs?: Hood_Phone_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Phone_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_phone_body(inputs)
});